export enum ProductType {
  BEVERAGE = 0,
  FOOD = 1,
}
export enum CustomizationType {
  SIDE = 0,
  OTHER = 1,
}
